// «Повторить движение» в виджете генератора (владелец 23.10: «привяжи отображение к условию, которое в админке
// включает и выключает staff для этого функционала»). Кому видна кнопка, решает рубильник в админке
// («Настройки → Меню сайта», строка «Повторить движение» под «Видео»): all — всем, staff — только сотрудникам,
// off — никому. Пока карта режимов грузится, действует значение из кода («только сотрудникам») — у клиента
// ничего не мигнёт. Ссылка /generate?tool=motion от рубильника не зависит.
import { featureOpen, navMode } from '../api/nav'
import { useAuth } from '../context/AuthContext'
import { isStaff } from '../utils/roles'
import { useNavModes } from './useNavModes'

export function useMotionToolOpen(): boolean {
	const { user } = useAuth()
	const { modes } = useNavModes()
	return featureOpen(navMode(modes, 'motion_tool'), isStaff(user?.role))
}
